var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5Plus = function SvgAv5Plus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-variant": "regular",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-no-fill": "true",
    d: "M5.126 1v8.253M1 5.127h8.253",
    stroke: "#002774",
    strokeWidth: 1.297,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export { SvgAv5Plus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLXZhcmlhbnQ9InJlZ3VsYXIiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZGF0YS1uby1maWxsPSJ0cnVlIgogICAgICAgIGQ9Ik01LjEyNjQ2IDFWOS4yNTM0NyIKICAgICAgICBzdHJva2U9IiMwMDI3NzQiCiAgICAgICAgc3Ryb2tlLXdpZHRoPSIxLjI5Njg1IgogICAgICAgIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIKICAgICAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAvPgogICAgPHBhdGgKICAgICAgICBkYXRhLW5vLWZpbGw9InRydWUiCiAgICAgICAgZD0iTTEgNS4xMjcwMUg5LjI1MzQ3IgogICAgICAgIHN0cm9rZT0iIzAwMjc3NCIKICAgICAgICBzdHJva2Utd2lkdGg9IjEuMjk2ODUiCiAgICAgICAgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIgogICAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIC8+Cjwvc3ZnPgo=";